import React, { useState, useEffect } from "react";
import contactImage from "../Assets/IMG/thanos.png";

const ContactForm = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [result, setResult] = useState("");

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");
    const formData = new FormData(event.target);

    formData.append("access_key", "8575db0a-d712-45bb-a231-82873de4c9bd");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("✅ Form Submitted Successfully!");
      event.target.reset();
    } else {
      console.error("Error:", data);
      setResult(`❌ ${data.message}`);
    }
  };

  const inputStyle = {
    width: "95%",
    padding: "14px",
    marginBottom: "10px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    backgroundColor: "#fff",
    fontSize: "16px",
  };

  const buttonStyle = {
    backgroundColor: "#c52091",
    color: "#fff",
    padding: "12px 20px",
    fontSize: "16px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    marginTop: "10px",
    fontWeight: "bold",
    width: "100%",
  };

  return (
    <div
      style={{
        padding: "30px 20px",
        background: "linear-gradient(135deg, #141418, #191e35)",
        color: "#fff",
      }}
    >
      {/* Top Heading */}
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <h2 style={{ fontSize: "26px", fontWeight: "bold" }}>
          Give Us 100 Days. We’ll Give
          <br />
          You a Brand Even Thanos Couldn’t Snap Away
        </h2>
      </div>

      {/* Image + Form Section */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: "40px",
          maxWidth: "1100px",
          margin: "0 auto",
          alignItems: "flex-start",
        }}
      >
        {/* Image */}
        <div style={{ flex: 1, textAlign: "center" }}>
          <img
            src={contactImage}
            alt="Thanos"
            style={{
              width: "100%",
              maxWidth: "400px",
              height: "auto",
              borderRadius: "10px",
              objectFit: "cover",
            }}
          />
        </div>

        {/* Form */}
        <div style={{ flex: 1 }}>
          <form onSubmit={onSubmit}>
            {/* Row 1 */}
            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: "20px",
                marginBottom: "10px",
              }}
            >
              <input style={inputStyle} name="name" type="text" placeholder="Name *" required />
              <input
                style={inputStyle}
                name="email"
                type="email"
                placeholder="Work Email *"
                required
              />
            </div>

            {/* Row 2 */}
            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                gap: "20px",
                marginBottom: "10px",
              }}
            >
              <input
                style={inputStyle}
                name="phone"
                type="tel"
                placeholder="Phone Number *"
                required
              />
              <select style={inputStyle} name="budget" required>
                <option value="">Your Budget? *</option>
                <option value="15-30">15K - 30K</option>
                <option value="30-50">30K - 50K</option>
                <option value="50-100">50K - 1L</option>
                <option value="100+">1Lac +</option>
              </select>
            </div>

            {/* Textarea */}
            <textarea
              style={{ ...inputStyle, height: "120px", resize: "vertical" }}
              name="message"
              placeholder="How can we help?"
              required
            />

            {/* Button */}
            <button type="submit" style={buttonStyle}>
              Send Message
            </button>

            {/* Result Message */}
            {result && (
              <p style={{ color: "#0f0", marginTop: "10px", fontWeight: "500" }}>{result}</p>
            )}
          </form>
        </div>
      </div>

      {/* Bottom Heading */}
      <h2
        style={{
          textAlign: "center",
          marginTop: "40px",
          fontSize: "20px",
          maxWidth: "900px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        Where Iron Man’s brains, Loki’s mischief, and Hulk’s punch build digital empires 3X faster
      </h2>
    </div>
  );
};

export default ContactForm;
